import { Breadcrumb, Upload, Typography, Modal, Row, Col, Button, Space, Radio, Card, Input, Select, Checkbox, DatePicker } from 'antd';
import React, { useEffect, useState } from 'react';
import { Navigate, Outlet, useNavigate, useLocation } from 'react-router-dom'
import { InboxOutlined, PlusOutlined } from '@ant-design/icons';
import axios from 'axios';
import AdminModal from './AdminModal';
import dayjs from 'dayjs'
const { Title, Paragraph, Text, Link } = Typography;
const { TextArea } = Input;

const DetailModal = (props) => {
    const [grade_option, set_grade_option] = useState([]);
    const [learn_english_year, set_learn_english_year] = useState([]);
    useEffect(() => {
        get_grade();
        get_learn_english();
    }, [])
    const get_grade = () => {
        axios
            .get('/cramSchool/api/grade')
            .then((response) => {
                let data_tmp = [];
                response.data.data.map((value, index) => {
                    let data_json_tmp = {};
                    data_json_tmp['value'] = value['id']
                    data_json_tmp['label'] = `${value['name']}`;
                    data_tmp.push(data_json_tmp);
                })
                set_grade_option(data_tmp)
            })
    }
    const get_learn_english = () => {
        axios
            .get('/cramSchool/api/learn_english_year')
            .then((response) => {
                let data_tmp = [];
                response.data && response.data.map((value, index) => {
                    let data_json_tmp = {};
                    data_json_tmp['value'] = value['learn_english_year_id']
                    data_json_tmp['label'] = `${value['name']}`;
                    data_tmp.push(data_json_tmp);
                })
                set_learn_english_year(data_tmp);
            })
    }
    return (
        <AdminModal
            {...props}
            title={(<>
                <Col style={{ fontWeight: 'bold', fontSize: '20px', position: 'absolute', zIndex: 99, top: 50, left: 30 }} >{props.title}</Col>
            </>)}
        >
            <Row gutter={[8, 8]} align={'middle'}>
                <Col span={7}>學生姓名</Col>
                <Col span={17}>
                    <Input placeholder={'請輸入學生姓名(必填)'} type='text' value={props.editcard.client} name="name" onChange={e => props.setEditCard(pre => ({ ...pre, client: e.target.value }))} />
                </Col>
                <Col span={7}>學生電話</Col>
                <Col span={17}>
                    <Input placeholder={'請輸入學生電話(必填)'} type='text' value={props.editcard.phone} name="phone" onChange={e => props.setEditCard(pre => ({ ...pre, phone: e.target.value }))} />
                </Col>
                <Col span={7}>就讀學校</Col>
                <Col span={17}>
                    <Input placeholder={'請輸入就讀學校(必填)'} type='text' value={props.editcard.school} name="school" onChange={e => props.setEditCard(pre => ({ ...pre, school: e.target.value }))} />
                </Col>
                <Col span={7}>學生當前年級</Col>
                <Col span={17}>
                    <Select
                        style={{
                            width: 250,
                        }}
                        labelInValue
                        value={props.editcard.grade_name}
                        placeholder='請輸入學生當前年級(必填)'
                        name="title"
                        onChange={(value) => {
                            props.setEditCard(prev => {
                                return (
                                    {
                                        ...prev,
                                        grade_id: value['value'],
                                        grade_name: value['label'],
                                    }
                                )
                            })
                        }}
                        options={grade_option}
                    >
                    </Select>
                </Col>
                <Col span={7}>在校成績</Col>
                <Col span={17}>
                    <Input placeholder={'請輸入在校成績（必填）'} type='text' value={props.editcard.school_score} name="school_score" onChange={e => props.setEditCard(pre => ({ ...pre, school_score: e.target.value }))} />
                </Col>
                <Col span={7}>學習英文時長</Col>
                <Col span={17}>
                    <Select
                        style={{
                            width: "100%",
                        }}
                        labelInValue
                        value={props.editcard['learn_english_year_id']}
                        onChange={(value) => props.setEditCard(pre => {
                            return ({
                                ...pre,
                                'learn_english_year_id': value.value,
                                'learn_english_year_name': value.label,
                            })
                        })}
                        options={learn_english_year}
                    />
                </Col>
                <Col span={7}>學生電子信箱</Col>
                <Col span={17}>
                    <Input placeholder={'請輸入學生電子信箱'} type='e_mail' value={props.editcard.e_mail} name="email" onChange={e => props.setEditCard(pre => ({ ...pre, e_mail: e.target.value }))} />
                </Col>
                <Col span={7}>檢定名稱</Col>
                <Col span={17}>
                    <Input placeholder={'請輸入檢定名稱'} type='text' value={props.editcard.test_name} name="test_name" onChange={e => props.setEditCard(pre => ({ ...pre, test_name: e.target.value }))} />
                </Col>
                <Col span={7}>詢問問題</Col>
                <Col span={17}>
                    <TextArea rows={4} type='text' value={props.editcard.question} name="note" placeholder="請輸入學生想詢問的問題" onChange={e => props.setEditCard(pre => ({ ...pre, question: e.target.value }))} />
                </Col>
                <Col span={7}>詢問時間</Col>
                <Col span={17}>
                    <DatePicker value={props.editcard.first_insert_time ? dayjs(props.editcard.first_insert_time) : null} onChange={(_, e) => props.setEditCard(pre => ({ ...pre, first_insert_time: e }))} />
                </Col>
            </Row>
        </AdminModal>
    )

}
export default DetailModal;